const productData = [
    {
      id: 0,
      name: "STARLINK VPN",
      image:
        "https://i.ibb.co/NFWPLbQ/app-main-logo.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/fixbuildvw/vpnapklink/-/raw/main/app.fixbuild.StarLinKxVPN-release.apk"
    },{
      id: 1,
      name: "CloudLink V2Ray",
      image:
        "https://i.postimg.cc/ryDJzTWz/temp-Imagee75j3h.avif",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY", "SlowDns", "SSH", "WireGuard"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/fixbuildvw/starlinkvpn/-/raw/main/app.fixbuild.vpncore.cloudlinkv2ray-6.0-release.apk"
    },{
      id: 2,
      name: "STARLINK V2RayN",
      image:
        "https://i.postimg.cc/C1JRr9K0/starlinkv2ray.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY", "SlowDns", "SSH", "WireGuard"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/fixbuildvw/starlinkvpn/-/raw/main/app.fixbuild.vpncore.starlinkv2ray-4.1-release.apk"
    },
    {
      id: 3,
      name: "STARLINK VPN",
      image:
        "https://i.ibb.co/NFWPLbQ/app-main-logo.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/fixbuildvw/vpnapklink/-/raw/main/app.fixbuild.StarLinKxVPN-release.apk"
    },
    {
      id: 4,
      name: "SAFELINK PSIPHON",
      image:
        "https://i.ibb.co/NFWPLbQ/app-main-logo.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://gitlab.com/fixbuildvw/starlinkvpn/-/raw/main/starlink.psiphon-release.apk"
    },
    {
      id: 5,
      name: "SAFELINK PROXY",
      image:
        "https://i.postimg.cc/K80Q9v34/privacy-16981017.png",
      productType: "openBackHeadphones",
      description: ["OVPN", "UDP", "V2RAY"],
      rating: 5,
      timeLeft: 27,
      appLink: "https://tinyurl.com/SafeLinkProxy-Ap"
    }
    // {
    //   id: 4,
    //   name: "SECURE TUNNEL",
    //   image:
    //     "https://i.postimg.cc/wMW7LWFC/keyhole-958517.png",
    //   productType: "openBackHeadphones",
    //   description: ["OVPN", "UDP", "V2RAY"],
    //   rating: 5,
    //   timeLeft: 24,
    //   appLink: "https://tinyurl.com/StarLinkVPNnew-Apk"
    // }
  ];
  export default productData;
